
<template>
    <div class="adserach_main" :style="{'background-image':'url('+adimgsrc+')'}">
        <div class="adsearch_main_search">
            <ad-search></ad-search>
        </div>
    </div>
</template>
<script>
/*!
 *底部为广告位的search框
 */
import adSearch from "./searchAndselect.vue";
import { mapGetters, mapActions } from "vuex";
import { getModuleInfo, getModulStyle } from "./../services/api.js";
export default {
  data() {
    return {
        adimgsrc:""
    };
  },
  components: { adSearch },
  created() {
      //this.getADInfo();
  },
   computed: {
    ...mapGetters(["webModels", "curModelInfo","modelsInfo","webID"]),
    //channel_id() {
    //  return this.modelsInfo.filter(item => item.tpl_id == 6)[0].id;
    //}
  },
  methods: {
    getADInfo() {
      let data = {
        module_id: 12, //轮播图的module_id始终固定为2
        web_id: this.webID,
        use_sort_num: 1,
        channel_id: this.channel_id //this.curModelInfo.id //频道id
      };
      getModuleInfo(data).then(res => {
        if (res.status_code == 1) {
          this.adimgsrc = res.data.list[0].photo1;
        }
      });
    }
  }
};
</script>
<style lang="less">
.adserach_main {
  height: 130px;
  line-height: 130px;
  width: 100%;
  background-color: #d4d4d4;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  .adsearch_main_search {
    width: 900px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/adSearch.vue